import React from "react";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="page-width page-width--narrow section-template--19439205515429__main-padding">
      <h1 className="main-page-title page-title h0 scroll-trigger animate--fade-in">
        shipping
      </h1>
      <div className="rte scroll-trigger animate--slide-in">
        <p>
          We use tracked international and local delivery partners selected for
          each destination.&nbsp;
        </p>
        <p>We do not make a profit on shipping.</p>
        <p>
          <strong>
            Most orders ship out within 1 business day.{" "}
            <span style={{ textDecoration: "underline" }}>
              During holidays fulfillment time may take longer.
            </span>
          </strong>
        </p>
        <p>
          We are not responsible for customs or related duties and taxes.&nbsp;
        </p>
        <p>
          <strong>Please note:</strong>
        </p>
        <ul>
          <li>Special order items may have extended delivery times.</li>
          <li>International delivery can take 2-3 weeks in some cases.</li>
        </ul>
        <p>&nbsp;</p>
      </div>
    </div>
  );
}

export default Delivery;
